import React from 'react';
import clsx from 'clsx';

const SettingsContainer = ({ children, size = 'lg' }) => {
  return (
    <div
      className={clsx('', {
        'max-w-lg': size === 'lg',
        'max-w-xl': size === 'xl',
        'max-w-2xl': size === '2xl',
        'max-w-4xl': size === '4xl',
      })}
    >
      {children}
    </div>
  );
};

export default SettingsContainer;
